"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casali-del-manco": {
    "9d0f0a46": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "skipSearch": false
    }],
    "cribari": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed64261e": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "skipSearch": false
    }],
    "feruci": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3ea7c871": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "skipSearch": false
    }],
    "macchia": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2980492": [{
      "hkey": "53c7588f",
      "slug": "morelli-catena-sottana",
      "name": "Morelli Catena Sottana",
      "primary": true,
      "skipSearch": false
    }],
    "morelli": [{
      "hkey": "53c7588f",
      "slug": "morelli-catena-sottana",
      "name": "Morelli Catena Sottana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0b4dd841": [{
      "hkey": "6fad1eaf",
      "slug": "pedace-perito",
      "name": "Pedace-Perito",
      "primary": true,
      "skipSearch": false
    }],
    "pedace": [{
      "hkey": "6fad1eaf",
      "slug": "pedace-perito",
      "name": "Pedace-Perito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casali-del-manco"
    }],
    "98919971": [{
      "hkey": "6fad1eaf",
      "slug": "pedace-perito",
      "name": "Pedace-Perito",
      "primary": true,
      "skipSearch": false
    }],
    "perito": [{
      "hkey": "6fad1eaf",
      "slug": "pedace-perito",
      "name": "Pedace-Perito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casali-del-manco"
    }],
    "716211b4": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "skipSearch": false
    }],
    "righio-o-rigio": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5045ec91": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "90c19f59",
      "slug": "casali-del-manco",
      "name": "Casali del Manco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;